import { DP_IDS_HOLDING, DP_TRANSACTION_HISTORY_HOLDING, DP_TRANSACTION_HISTORY_LOADER, DP_TRANSACTION_MAIN_LOADER, EMPTY_DP_TRANSACTION_VALIDATION, HIDE_EMPTY_DP_TRANSACTION_VALIDATION, HOLDING_EMPTY_VALIDATION, HOLDING_ERROR, HOLDING_HIDE_EMPTY_VALIDATION, HOLDING_HIDE_ERROR, HOLDING_LOADER, HOLDING_REPORT, PROD_ASSET_FILTER_VAL_HOLDING, SAVE_SMTF, } from "../../interfaces/Reports/iHoldingReport";
import { UNDERSTANDING_ERROR, UNDERSTANDING_HIDE_ERROR, UNDERSTANDING_SECTION, } from "../../interfaces/Reports/iUnderstandingSection";
import store from "../../store";
var HoldingReportsActions = /** @class */ (function () {
    function HoldingReportsActions() {
        this.dispatch = store.dispatch;
    }
    HoldingReportsActions.prototype.setHoldingLoader = function (loader) {
        this.dispatch({
            type: HOLDING_LOADER,
            payload: { loader: loader },
        });
    };
    HoldingReportsActions.prototype.setEmptyDPValidation = function (emptyValidation) {
        this.dispatch({
            type: EMPTY_DP_TRANSACTION_VALIDATION,
            payload: { emptyDpTransaction: emptyValidation.emptyDpTransaction },
        });
    };
    HoldingReportsActions.prototype.hideDPEmptyValidation = function () {
        this.dispatch({
            type: HIDE_EMPTY_DP_TRANSACTION_VALIDATION,
        });
    };
    HoldingReportsActions.prototype.setEmptyValidation = function (emptyValidation) {
        this.dispatch({
            type: HOLDING_EMPTY_VALIDATION,
            payload: emptyValidation,
        });
    };
    HoldingReportsActions.prototype.hideEmptyValidation = function () {
        this.dispatch({
            type: HOLDING_HIDE_EMPTY_VALIDATION,
        });
    };
    HoldingReportsActions.prototype.getHoldingReportData = function (HoldingReportEntityList) {
        this.dispatch({
            type: HOLDING_REPORT,
            payload: {
                data: HoldingReportEntityList,
            },
        });
    };
    HoldingReportsActions.prototype.getDpIds = function (dpTransactionEntity) {
        this.dispatch({
            type: DP_IDS_HOLDING,
            payload: {
                dpTransactionEntity: dpTransactionEntity,
            },
        });
    };
    HoldingReportsActions.prototype.setDpTransactionHistory = function (dpTransactionEntity) {
        this.dispatch({
            type: DP_TRANSACTION_HISTORY_HOLDING,
            payload: {
                dpTransactionEntity: dpTransactionEntity,
            },
        });
    };
    HoldingReportsActions.prototype.getUnderstandingSectionData = function (understand) {
        this.dispatch({
            type: UNDERSTANDING_SECTION,
            payload: {
                data: understand,
            },
        });
    };
    HoldingReportsActions.prototype.toggleDpTransactionMainLoader = function (shimer) {
        this.dispatch({
            type: DP_TRANSACTION_MAIN_LOADER,
            payload: {
                dpTransactionMainLoader: shimer,
            },
        });
    };
    HoldingReportsActions.prototype.toggleDpTransactionLoader = function (shimer) {
        this.dispatch({
            type: DP_TRANSACTION_HISTORY_LOADER,
            payload: {
                dpTransactionLoader: shimer,
            },
        });
    };
    HoldingReportsActions.prototype.setError = function (payload, errorType) {
        this.dispatch({
            type: HOLDING_ERROR,
            payload: {
                errorData: payload,
            },
            errorType: errorType,
        });
    };
    HoldingReportsActions.prototype.hideError = function (errorType) {
        this.dispatch({
            type: HOLDING_HIDE_ERROR,
            errorType: errorType,
        });
    };
    HoldingReportsActions.prototype.setErrorUnderStandings = function (payloadError) {
        this.dispatch({
            type: UNDERSTANDING_ERROR,
            payload: {
                errorData: payloadError,
            },
        });
    };
    HoldingReportsActions.prototype.hideUnderstandingError = function () {
        this.dispatch({
            type: UNDERSTANDING_HIDE_ERROR,
        });
    };
    HoldingReportsActions.prototype.saveProdAssetDropDown = function (prodDropDown) {
        this.dispatch({
            type: PROD_ASSET_FILTER_VAL_HOLDING,
            payload: { prodDropDown: prodDropDown },
        });
    };
    HoldingReportsActions.prototype.saveSMTF = function (smtf) {
        this.dispatch({
            type: SAVE_SMTF,
            payload: { smtf: smtf },
        });
    };
    return HoldingReportsActions;
}());
export default HoldingReportsActions;
